const contentStory = () => import("@/pages/content/story/index.vue");
const contentForm = () => import("@/pages/content/story/form.vue");

export default [
    {
        path: "/content/story",
        component: contentStory,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "杰锐德故事",
                activeRoute: "/content/story",
            },
        ],
    },
    {
        path: "/content/story/form",
        component: contentForm,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "杰锐德故事",
                url: "/content/story",
            },
            {
                name: "新增/编辑",
                activeRoute: "/content/story",
            },
        ],
    },
];
